import { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@material-ui/core';
import Notify from '../Notify';
import Content from '../Content';
import { systemAPI } from '../../../../apis';
import { notifyP } from '../../bsApp';
import { useGetUserInfo } from '../../../../utils';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.font.white,
    borderTopRightRadius: '15px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flex: '1',
    borderRadius: '0 0.937rem 0.937rem 0.937rem',
  },
  list: {
    '&>div': {
      borderBottom: 'solid 1px #ddd',
    },
  },
}));

export default function Scheduled({ sendFlag, setSendFlag }) {
  const classes = useStyles();
  const PAGESIZE = 20;
  const CATEGORY = 'SCHEDULED';
  const rouList = useSelector((state) => state.rouList);
  const loginInfo = useSelector((state) => state.loginInfo);
  const tableRef = useRef(null);
  const userInfo = useGetUserInfo();
  const [loadingFlag, setLoadingFlag] = useState(false);

  const deleteNotificationAPI = async (id) => {
    try {
      await systemAPI.deleteNotification({ notificationIds: [id] });
      await getSysNotificationList(PAGESIZE, 1);
    } catch (error) {
      console.log('=========deleteNotificationAPI error===========>', error);
    }
  };

  useEffect(() => {
    if (sendFlag) {
      (async () => {
        await getSysNotificationList(PAGESIZE, 1, true);
      })();
      tableRef.current.scrollTo(0, 0);
      setSendFlag(false);
    }
  }, [sendFlag]);

  const [notificationList, setNotificationList] = useState([]);
  const [count, setCount] = useState(null);
  const getSysNotificationList = async (pageSize, pageNo, loading) => {
    try {
      loading && setLoadingFlag(true);
      const { result } = await systemAPI.getSysNotificationList(
        {
          category: CATEGORY,
          pageSize: pageSize,
          pageNum: pageNo,
          wardId: loginInfo.wardId,
          corpId: loginInfo.corpID,
          roleTypeId: userInfo.roleTypeId,
        },
        { isHideLoading: true }
      );
      loading && setLoadingFlag(false);
      setCount(result?.count ?? 0);
      const newNotificationList = [...notificationList.slice(0, (pageNo - 1) * pageSize), ...(result?.data ?? [])];
      setNotificationList(newNotificationList);
      return result?.data;
    } catch {}
    return null;
  };

  const [isInit, setIsinit] = useState(false);
  const nextPageCall = async (pageSize, pageNo, loading) => {
    try {
      if (count === null || count > notificationList.length) {
        if (count === null) {
          setIsinit(true);
        }
        await getSysNotificationList(pageSize, pageNo, loading);
      }
    } catch (error) {
      console.log('-----Ward error-----', error);
    }
  };

  useEffect(() => {
    if (isInit) {
      tableRef.current.scrollTo(0, 0);
      setCount(null);
      (async () => {
        await getSysNotificationList(PAGESIZE, 1, true);
      })();
    }
  }, [rouList]);

  return (
    <div className={classes.root}>
      {loadingFlag ? (
        <Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center">
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <Content
          className={classes.list}
          nextPageCall={nextPageCall}
          id="Notification-Content-abk"
          allData={notificationList}
          pageSize={PAGESIZE}
          ref={tableRef}
        >
          {notificationList.map((item, index) => (
            <Notify
              key={item.notificationId}
              allData={item}
              type={notifyP.scheduled}
              deleteNotificationAPI={deleteNotificationAPI}
              id={`Notification-Notify-abl-${index}`}
            />
          ))}
        </Content>
      )}
    </div>
  );
}
